module.exports = __webpack_public_path__ + "img/2.9927d102.png";